'use client'

import { identifyUser } from 'analytics-utils/src'
import { useSession } from 'next-auth/react'
import { useEffect } from 'react'

/**
 * Hook that automatically identifies users with RudderStack when their session changes
 * Should be called once in the app root to track user identification events
 */
export function useAnalyticsIdentify(): void {
  const { data: session, status } = useSession()

  useEffect(() => {
    // Only identify when we have an authenticated session
    if (status !== 'authenticated' || !session?.user) {
      return
    }

    const user = session.user

    // Ensure we have a profileId for the user
    if (!user.profileId) {
      console.warn('skipping identify - missing user.profileId')
      return
    }

    // Call identifyUser with all available user data
    identifyUser({
      publicAddress: user.publicAddress,
      isStaff: user.isStaff ?? false,
      chain: user.chain,
      email: user.emailAddress,
      name: user.name,
      username: user.username,
      profileId: user.profileId
    })
  }, [session, status])
}
